"use client";
import { useEffect } from "react";
import { dirOf } from "./config";

/** Keeps <html lang/dir> in sync on client-side navigations (the root layout only renders on full loads). */
export function HtmlLang({ locale }: { locale: string }) {
  useEffect(() => {
    const el = document.documentElement;
    el.lang = locale;
    el.dir = dirOf(locale);
  }, [locale]);
  return null;
}
